import { type Action, createReducer, on } from '@ngrx/store';

import { resetNavigationState, switchView } from './navigation.actions';
import { type UploaderView } from './uploader-view';

export interface NavigationState {
  activeView: UploaderView;
}

export const initialState: NavigationState = {
  activeView: 'source-from-computer',
};

const navigationReducerFn = createReducer(
  initialState,
  on(resetNavigationState, () => ({ ...initialState })),
  on(switchView, (state, { view }) => ({ ...state, activeView: view })),
);

export function navigationReducer(
  state: NavigationState | undefined,
  action: Action,
): NavigationState {
  return navigationReducerFn(state, action);
}
